import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";

import { cn } from "@/lib/utils";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "border-3 order-zinc-200 peer h-6 w-6 shrink-0 rounded-sm border-2 border-zinc-200 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-2 data-[state=checked]:border-primaryBrand data-[state=checked]:bg-primaryBrand data-[state=checked]:text-primaryBrand",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={cn("flex h-full w-full items-center justify-center text-current")}>
      <Check className="h-4 w-4 items-center justify-center align-middle text-white" strokeWidth={3} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
